module.exports = __webpack_public_path__ + "img/et.bfb8f89f.svg";